export default __webpack_public_path__ + "static/media/hourglass.7256bfb2.svg";